import React from "react";
import { IconButton, useMediaQuery } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

export const BoutonSave = ({ onClick, disabled = false }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        color: "#71685e",
        "&:hover": { color: "#388E3C", backgroundColor: "transparent" },
        width: isMobile ? 28 : 36,
        height: isMobile ? 28 : 36,
        borderRadius: 1
      }}
    >
      <SaveIcon fontSize="inherit" sx={{ fontSize: isMobile ? "1rem" : "2rem" }} />
    </IconButton>
  );
};

export const BoutonCancel = ({ onClick }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <IconButton
      onClick={onClick}
      sx={{
        color: "#f44336",
        "&:hover": { color: "#d32f2f", backgroundColor: "transparent" },
        width: isMobile ? 28 : 36,
        height: isMobile ? 28 : 36,
        borderRadius: 1
      }}
    >
      <CloseIcon fontSize="inherit" sx={{ fontSize: isMobile ? "1rem" : "2rem" }} />
    </IconButton>
  );
};
